import { v4 as uuidv4 } from 'uuid';

export function getNewCellID() {
  return `cell_${uuidv4()}`;
}
